/* esm.sh - fast-png@8.0.0 */
export * from "/*fast-png@8.0.0/esnext/fast-png.mjs";
